import React, { useState } from "react";

const rgbString = (rgb: Array<number>) => {
    const [r, g, b] = rgb;
    return `rgb(${r},${g},${b})`
}

const randomColor = (): Array<number> => {
    return [Math.random() * 255, Math.random() * 255, Math.random() * 255];
}

const randomRGB = (): string => {
    return rgbString(randomColor());
}

// const initialColor = rgbString([250, 250, 250]);

function LoadingBar(props: {
    fadeTime: number,
    height: number
}) {

    const [color, setColor] = useState<string>()
    const [done, setDone] = useState<boolean>(false);


    if (!done) {
        setTimeout(() => {
            setDone(true);
            setColor(randomRGB());
        }, props.fadeTime + props.fadeTime)
    }

    return (
        <div style={{
            height: `${props.height}px`,
            backgroundColor: color,
            transition: "background-color 5s"
        }}
            className="LoadingBar"
        >
        </div>
    )
}

export default function LoadingPage(props: {}) {

    const barCount = 1800 / 40;
    const pageHeight = 1800;

    return (
        <main
            style={{
                overflow: "hidden"
            }}

            className="LoadingPage">
            {Array(barCount).fill(0).map((n: number, i: number) => {
                return <LoadingBar
                    height={pageHeight / barCount}
                    key={i}
                    fadeTime={i * 100} />
            })}
        </main>
    );
}